import { logger } from './logger'

/** The values that identify this session's records in Fun's log search. */
export interface FunkitTraceInfo {
  /** The active flow's checkout id, or null when no flow is open. */
  traceId: string | null
  /** Whatever the host passed as `FunkitConfig.debugTag`. */
  debugTag: string | null
}

export function getFunkitTraceInfo(): FunkitTraceInfo {
  return { traceId: logger.getTraceId(), debugTag: logger.getDebugTag() }
}

/** Send buffered records now rather than waiting out the batch timer. */
export function flushFunkitLogs(): void {
  logger.flush()
}

/** Route host-side debug events through the configured Funkit log pipeline. */
export function logFunkitEvent(
  title: string,
  data?: Record<string, unknown>,
): void {
  logger.info(title, data)
}
